import { DEMO_LOGINS, LIVE_LOGINS_WITHOUT_CRM } from '@webtrader/core/constants/account';
import { authService } from '@webtrader/core/services/auth';

import { INormalizeSelectedTabParams } from './types';

export const normalizeSelectedTab = ({ selectedTab, companyAccess }: INormalizeSelectedTabParams) => {
  const { mt4LiveLoginConfig, mt4DemoLoginConfig, mt5LiveLoginConfig, mt5DemoLoginConfig } = companyAccess;

  if (!selectedTab) {
    return selectedTab;
  }

  if (LIVE_LOGINS_WITHOUT_CRM.includes(selectedTab)) {
    const liveLoginType = authService.getLiveLoginTypeFromCompanyAccess({ mt5LiveLoginConfig, mt4LiveLoginConfig });
    return liveLoginType || selectedTab;
  }

  if (DEMO_LOGINS.includes(selectedTab)) {
    const demoLoginType = authService.getDemoLoginTypeFromCompanyAccess({ mt5DemoLoginConfig, mt4DemoLoginConfig });
    return demoLoginType || selectedTab;
  }

  return selectedTab;
};
